import { FC, useState, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';
import { NOT_FOUND_ERROR_PAGE_PATH } from 'src/app/common/constants';
import { LayoutSplashScreen } from 'src/app/layout';
import ContractSettingForm from './components/contract-setting-form';
import { ContractDataFormMode, ContractSettingItem } from '../../../types/contract-setting-types';
import { fetchContractSettingItem } from '../../../network/contract-setting-crud';

const ContractSettingDetailPage: FC = () => {
  const { id } = useParams<{ id: string }>();
  const formMode = useMemo(() => (id ? ContractDataFormMode.EDIT : ContractDataFormMode.CREATE), [id]);
  const dispatch = useDispatch();
  const history = useHistory();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [contractSettingItem, setContractSettingItem] = useState<ContractSettingItem>();

  useEffect(() => {
    if (id) {
      setIsLoading(true);
      fetchContractSettingItem(id, dispatch)
        .then((res) => setContractSettingItem(res))
        .catch(() => history.push(NOT_FOUND_ERROR_PAGE_PATH))
        .finally(() => setIsLoading(false));
    }
  }, [id]);

  return (
    <>
      {formMode === ContractDataFormMode.CREATE && <ContractSettingForm formMode={formMode} />}
      {formMode !== ContractDataFormMode.CREATE &&
        (isLoading || !contractSettingItem ? (
          <LayoutSplashScreen />
        ) : (
          <ContractSettingForm formMode={formMode} contractSettingItem={contractSettingItem} />
        ))}
    </>
  );
};

export default ContractSettingDetailPage;
